import { LISTINGS } from '@/tooltips';

import type { ConfigListingColumns, ListingNameColumnConfig } from './types';

export const TABLE_LISTINS_CONFIG_COLUMNS_ACTIVE: ConfigListingColumns = {
  title: {
    index: 2,
    visible: true,
    disabled: true,
  },
  menu: {
    index: 3,
    visible: true,
    disabled: true,
  },
  views: {
    index: 4,
    visible: true,
  },
  grade: {
    index: 5,
    visible: true,
    disabled: false,
  },
  price: {
    index: 6,
    visible: true,
  },
  total_sales: {
    index: 7,
    visible: true,
    sortable: true,
  },
  image_count: {
    index: 8,
    visible: true,
  },
  tag_count: {
    index: 9,
    visible: true,
  },
  age: {
    index: 10,
    visible: true,
  },
  quantity: {
    index: 11,
    visible: true,
  },
  superstar_keyword: {
    index: 12,
    visible: true,
  },
  sku: {
    index: 13,
    visible: true,
  },
  is_tracking: {
    index: 14,
    visible: true,
  },
  listing_id: {
    index: 15,
    visible: false,
    sortable: false,
  },
  visibility_score: {
    index: 16,
    visible: false,
  },
  inventory_value: {
    index: 17,
    visible: false,
  },
  original_creation_timestamp: {
    index: 18,
    visible: false,
  },
  ending_timestamp: {
    index: 19,
    visible: false,
  },
  last_modified_timestamp: {
    index: 20,
    visible: false,
  },
  categories: {
    index: 21,
    visible: false,
  },
  notes: {
    index: 22,
    visible: false,
  },
  url: {
    index: 23,
    visible: false,
  },
  tags: {
    index: 24,
    visible: false,
  },
  taxonomy_url: {
    index: 25,
    visible: false,
  },
  spelling_issues: {
    index: 26,
    visible: true,
  },
  total_revenue: {
    index: 27,
    visible: true,
    sortable: true,
  },
  listing_review_count: {
    index: 28,
    visible: false,
  },
  listing_average_rating: {
    index: 29,
    visible: false,
  },
  listing_type: {
    index:30,
    visible: true,
    sortable: false,
  },
  is_physical: {
    index: 31,
    visible: false,
  },
};

export const TABLE_LISTINS_CONFIG_COLUMNS_DRAFT: ConfigListingColumns = {
  // id: {
  //   index: 1,
  //   visible: true,
  // },
  // thumbnail: {
  //   index: 2,
  //   visible: true,
  // },
  title: {
    index: 2,
    visible: true,
    disabled: true,
  },
  listing_id: {
    index: 3,
    visible: true,
    sortable: false,
  },
  sku: {
    index: 4,
    visible: true,
  },
  image_count: {
    index: 5,
    visible: true,
  },
  tag_count: {
    index: 6,
    visible: true,
  },
};

export const TABLE_LISTINS_CONFIG_COLUMNS_EXPIRED: ConfigListingColumns = {
  // id: {
  //   index: 1,
  //   visible: true,
  // },
  // thumbnail: {
  //   index: 2,
  //   visible: true,
  // },
  title: {
    index: 3,
    visible: true,
    disabled: true,
  },
  listing_id: {
    index: 4,
    visible: true,
    sortable: false,
  },
  sku: {
    index: 5,
    visible: true,
  },
  ending_timestamp: {
    index: 6,
    visible: true,
  },
};

export const TABLE_LISTINS_CONFIG_COLUMNS_SOLD_OUT: ConfigListingColumns = {
  // id: {
  //   index: 1,
  //   visible: true,
  // },
  // thumbnail: {
  //   index: 2,
  //   visible: true,
  // },
  title: {
    index: 3,
    visible: true,
    disabled: true,
  },
  listing_id: {
    index: 4,
    visible: true,
    sortable: false,
  },
  sku: {
    index: 5,
    visible: true,
  },
  state_timestamp: {
    index: 6,
    visible: true,
  },
};

export const TABLE_LISTINGS_CONFIG_COLUMNS_THUMBNAIL_PREVIEW: ConfigListingColumns = {
  title: {
    index: 1,
    visible: true,
  },
  landscape_thumbnail: {
    index: 2,
    visible: true,
  },
  square_thumbnail: {
    index: 3,
    visible: true,
  },
  portrait_thumbnail: {
    index: 4,
    visible: true,
  },
};

export const HEADER_TITLE_DICTIONARY = {
  active: {
    title:'Active Listings',
    tooltip: 'This section highlights the performance of each listing in your shop, areas for improvement, and other reports to help you analyze your shop listings.',
    url: 'https://hc.erank.com/en/articles/6964112-listings#h_e5f00299d7',
  },
  draft: {
    title:'Draft Listings',
    tooltip: 'The draft listing report shows your last 1,000 draft listings. Click Listing Audit for tips to optimize them before publishing on Etsy.',
    url: 'https://hc.erank.com/en/articles/6964112-listings#h_0e6de400f0',
  },
  expired: {
    title:'Expired Listings',
    tooltip: 'The expired listings report shows your last 1,000 expired listings.',
    url: 'https://hc.erank.com/en/articles/6964112-listings#h_818d86eb94',
  },
  sold_out: {
    title:'Sold Out',
    tooltip: 'The sold out listings report shows your last 1,000 sold out listings.',
    url: 'https://hc.erank.com/en/articles/6964112-listings#h_818d86eb94',
  },
  'thumbnail-preview': {
    title:'Thumbnail Preview',
    tooltip: 'Preview your thumbnails across Etsy formats and make sure your product stays centered and doesn’t get cropped.',
    url: 'https://hc.erank.com/en/articles/6964112-listings#h_818d86eb94',
  },
};

// Make config persistent on the database
export const NAME_ACTIVE_TABLE_CONFIG_COLUMNS = 'listing.active.table.config.columns.v3';
export const NAME_DRAFT_TABLE_CONFIG_COLUMNS = 'listing.draft.table.config.columns';
export const NAME_EXPIRED_TABLE_CONFIG_COLUMNS = 'listing.expired.table.config.columns';
export const NAME_SOLD_OUT_TABLE_CONFIG_COLUMNS = 'listing.sold_out.table.config.columns';
export const NAME_THUMBNAIL_PREVIEW_TABLE_CONFIG_COLUMNS = 'listing.thumbnail-preview.table.config.columns';

export const ROWS_PER_PAGE = 'listings_rows_per_page';
export const SHOP_SECTION_ID = 'shop_section_id';
export const PAGE_NUMBER = 'page_number';
export const SHOW_TRACKING_ONLY = 'show_tracking_only';

// Sort preferences
export const NAME_ACTIVE_TABLE_SORT_PREFERENCES = 'listing.active.table.sort.preferences';
export const NAME_DRAFT_TABLE_SORT_PREFERENCES = 'listing.draft.table.sort.preferences';
export const NAME_EXPIRED_TABLE_SORT_PREFERENCES = 'listing.expired.table.sort.preferences';
export const NAME_SOLD_OUT_TABLE_SORT_PREFERENCES = 'listing.sold_out.table.sort.preferences';
export const NAME_THUMBNAIL_PREVIEW_TABLE_SORT_PREFERENCES = 'listing.thumbnail-preview.table.sort.preferences';

export const listingNameColumnConfig: ListingNameColumnConfig = {
  id: {
    columnName: '#',
    columnTooltip: '',
  },
  is_tracking: {
    columnName: 'TRACKING',
    columnTooltip: '',
  },
  menu: {
    columnName: ' ',
    columnTooltip: '',
  },
  grade: {
    columnName: 'GRADE',
    columnTooltip: LISTINGS.grade,
  },
  listing_review_count: {
    columnName: 'REVIEW COUNT',
    columnTooltip: LISTINGS.listing_review_count,
  },
  listing_average_rating: {
    columnName: 'RECENT AVG RATING',
    columnTooltip: LISTINGS.listing_average_rating,
  },
  thumbnail: {
    columnName: 'IMAGE',
    columnTooltip: LISTINGS.thumbnail,
  },
  title: {
    columnName: 'LISTING',
    columnTooltip: LISTINGS.title,
  },
  listing_id: {
    columnName: 'LISTING ID',
    columnTooltip: LISTINGS.listing_id,
  },
  notes: {
    columnName: 'NOTES',
    columnTooltip: LISTINGS.notes,
  },
  sku: {
    columnName: 'SKU',
    columnTooltip: LISTINGS.sku,
  },
  original_creation_timestamp: {
    columnName: 'CREATED',
    columnTooltip: LISTINGS.original_creation_timestamp,
  },
  last_modified_timestamp: {
    columnName: 'LAST UPDATED',
    columnTooltip: LISTINGS.last_modified_timestamp,
  },
  ending_timestamp: {
    columnName: 'DATE EXPIRED',
    columnTooltip: LISTINGS.ending_timestamp,
  },
  state_timestamp: {
    columnName: 'DATE SOLD OUT',
    columnTooltip: LISTINGS.state_timestamp,
    bodyClass: 'pl-2 v3-body-semibold-600-line-height-auto align-top text-[--v3-global-textcolor] w-[150px]',
  },
  // seo_tips: {
  //   columnName: 'SEO TIPS',
  //   columnTooltip: LISTINGS.seo_tips,
  // },
  age: {
    columnName: 'AGE',
    columnTooltip: LISTINGS.age,
  },
  superstar_keyword: {
    columnName: 'SUPERSTAR KEYWORD',
    columnTooltip: 'A clear, multi-word phrase describing your product and matching how shoppers search on Etsy.',
  },
  visibility_score: {
    columnName: 'VISIBILITY SCORE',
    columnTooltip: LISTINGS.visibility_score,
  },
  views: {
    columnName: 'TOTAL VIEWS',
    columnTooltip: LISTINGS.views,
  },
  // actual_sales: {
  //   columnName: 'TOTAL SALES',
  //   columnTooltip: 'This is the number of times this listing has been sold since it was originally created',
  //   bodyClass: 'pl-2 v3-body-semibold-600-line-height-auto align-top text-[--v3-global-textcolor]',
  // },
  total_sales: {
    columnName: 'TOTAL SALES',
    columnTooltip: 'This is the number of times this listing has been sold since it was originally created',
    bodyClass: 'pl-2 v3-body-semibold-600-line-height-auto align-top text-[--v3-global-textcolor]',
  },
  total_revenue: {
    columnName: 'TOTAL REVENUE',
    columnTooltip: 'This is the total revenue generated by this listing since it was originally created',
    bodyClass: 'pl-2 v3-body-semibold-600-line-height-auto align-top text-[--v3-global-textcolor]',
  },
  tag_count: {
    columnName: 'TAG COUNT',
    columnTooltip: LISTINGS.tag_count,
  },
  image_count: {
    columnName: 'IMAGES',
    columnTooltip: LISTINGS.image_count,
  },
  categories: {
    columnName: 'CATEGORIES',
    columnTooltip: LISTINGS.categories,
  },
  spelling_issues: {
    columnName: 'SPELLING ISSUES',
    columnTooltip: LISTINGS.spelling_issues,
  },
  quantity: {
    columnName: 'QTY',
    columnTooltip: LISTINGS.quantity,
  },
  price: {
    columnName: 'ITEM PRICE',
    columnTooltip: LISTINGS.price,
  },
  inventory_value: {
    columnName: 'INVENTORY VALUE',
    columnTooltip: LISTINGS.inventory_value,
  },
  url: {
    columnName: 'URL',
    columnTooltip: LISTINGS.url,
  },
  tags: {
    columnName: 'TAGS',
    columnTooltip: LISTINGS.tags,
  },
  landscape_thumbnail: {
    columnName: 'Landscape (4:3)',
    columnTooltip: LISTINGS.landscape_thumbnail,
  },
  square_thumbnail: {
    columnName: 'Square (1:1)',
    columnTooltip: LISTINGS.square_thumbnail,
  },
  portrait_thumbnail: {
    columnName: 'Portrait (3:4)',
    columnTooltip: LISTINGS.portrait_thumbnail,
  },
  listing_type: {
    columnName: 'LISTING TYPE',
    columnTooltip: LISTINGS.listing_type,
  },
  is_physical: {
    columnName: 'FORMAT',
    columnTooltip: LISTINGS.format,
  },
};

export const currencyCode = {
  USD: '$',
  CAD: '$',
  EUR: '€',
  ILS: '₪',
  GBP: '£',
  MXN: '$',
  AUD: '$',
  NOK: 'kr',
  SGD: '$',
  JPY: '¥',
  MYR: 'RM',
  SEK: 'kr',
  DKK: 'kr',
  HKD: '$',
  TRY: '₺',
  PHP: '₱',
  NZD: '$',
  CHF: 'CHF',
  IDR: 'Rp',
  INR: '₹',
  VND: '₫',
  THB: '฿',
  MAD: 'MAD',
  ZAR: 'R',
  PLN: 'zł',
};

export const SEARCH_QUERY_KEY = 'listings.search_query';